import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, CardBody, Col, Row, Label, Input, FormGroup, Form} from 'reactstrap'
import CreatableSelect from '../Wps/CreatableSelect'

class PeopleFilter extends Component {
  constructor() {
    super()
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this)
  }

  static propTypes = {
    groupsList: PropTypes.array,
    companyList: PropTypes.array,
    filtersData: PropTypes.object.isRequired,
    formToggleFunction: PropTypes.func.isRequired,
    submitFunction: PropTypes.func.isRequired,
    updateFiltersFunction: PropTypes.func.isRequired,
    clearFiltersDataFunction: PropTypes.func.isRequired,
  }

  handleSelectValueChange(inputName) {
    let self = this

    function updateSelectValue(values) {
      let newValues = Array.isArray(values) ? values.map(o => Number(o.id)) : Number(values.id)
      self.props.updateFiltersFunction({[inputName]: newValues})
    }

    return updateSelectValue
  }

  render() {
    return (
      <div>
        <CardBody>
          <Form id="people-filters-form">
            <Row>
              <Col xs="12" sm="3">
                <Input
                  id="uuid-welder-filters-form"
                  name="uuid"
                  type="text"
                  value={this.props.filtersData.uuid || ''}
                  onChange={(e) => this.props.updateFiltersFunction({uuid: e.target.value})}
                  placeholder="UUID"
                />
              </Col>
              <Col xs="12" sm="3">
                <Input
                  id="first_name-people-filters-form"
                  name="first_name"
                  value={this.props.filtersData.first_name || ''}
                  onChange={(e) => this.props.updateFiltersFunction({first_name: e.target.value})}
                  type="text"
                  placeholder="First name"
                />
              </Col>
              <Col xs="12" sm="3">
                <Input
                  id="last_name-people-filters-form"
                  name="last_name"
                  value={this.props.filtersData.last_name || ''}
                  onChange={(e) => this.props.updateFiltersFunction({last_name: e.target.value})}
                  type="text"
                  placeholder="Last name"
                />
              </Col>
              <Col xs="12" sm="3">
                <Input
                  id="email-people-filters-form"
                  name="email"
                  value={this.props.filtersData.email || ''}
                  onChange={(e) => this.props.updateFiltersFunction({email: e.target.value})}
                  type="text"
                  placeholder="Email"
                />
              </Col>
            </Row>
            <br/>
            <Row>
              <Col xs="12" sm="3">
                <FormGroup>
                  <b>Anonymized</b>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="anonymized" checked={this.props.filtersData.anonymized === 'true'}
                        onChange={() => this.props.updateFiltersFunction({anonymized: 'true'})}
                      />Yes
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="anonymized" checked={this.props.filtersData.anonymized === 'false'}
                        onChange={() => this.props.updateFiltersFunction({anonymized: 'false'})}
                      />No
                    </Label>
                  </FormGroup>
                </FormGroup>
              </Col>

              <Col xs="12" sm="3">
                <FormGroup>
                  <b>Active</b>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="active" checked={this.props.filtersData.active === 'true'}
                        onChange={() => this.props.updateFiltersFunction({active: 'true'})}
                      />Yes
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="active" checked={this.props.filtersData.active === 'false'}
                        onChange={() => this.props.updateFiltersFunction({active: 'false'})}
                      />No
                    </Label>
                  </FormGroup>
                </FormGroup>
              </Col>

              <Col xs="12" sm="3">
                <FormGroup>
                  <b>User</b>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="user" checked={this.props.filtersData.user === 'true'}
                        onChange={() => this.props.updateFiltersFunction({user: 'true'})}
                      />Yes
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="user" checked={this.props.filtersData.user === 'false'}
                        onChange={() => this.props.updateFiltersFunction({user: 'false'})}
                      />No
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="radio" name="user" checked={this.props.filtersData.user === 'locked'}
                        onChange={() => this.props.updateFiltersFunction({user: 'locked'})}
                      />Locked
                    </Label>
                  </FormGroup>
                </FormGroup>
              </Col>

            </Row>
            <br/>
            <Row>
              <Col xs="12" sm="6">
                <CreatableSelect id="select-group-people-filters-form"
                  placeholder="Groups"
                  options={this.props.groupsList}
                  valueKey="id"
                  value={this.props.filtersData.group_ids || null}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('group_ids')}/>
              </Col>
              <Col xs="12" sm="6">
                <CreatableSelect id="select-company-people-filters-form"
                  placeholder="Company"
                  options={this.props.companyList}
                  valueKey="id"
                  value={this.props.filtersData.company_ids || null}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={this.handleSelectValueChange('company_ids')}/>
              </Col>
            </Row>
            <br/>
            <Button id="close-welder-filters-btn" color="danger" className="float-right"
              onClick={this.props.formToggleFunction}>
              <i className="fa fa-close"/> Close
            </Button>
            <Button id="clear-welder-filters-btn"
              className="float-right"
              onClick={() => {
                this.props.clearFiltersDataFunction()
              }}
            > <i className="fa fa-eraser"/> Clear
            </Button>
            <Button id="filter-welders-btn"
              color="primary"
              className="float-right"
              onClick={() => {
                this.props.submitFunction()
              }}
            >
              <i className="fa fa-filter"/> Apply
            </Button>
            <br/> <br/>
          </Form>
        </CardBody>
      </div>
    )
  }
}

export default PeopleFilter



// WEBPACK FOOTER //
// ./src/components/People/PeopleFilter.js